import { useState } from 'react';
import { BsPencilSquare, BsTrash } from 'react-icons/bs';
import Modal from './Modal';

const WeightListItem = ({ date, weight, onDelete, weightUnit, onEditWeight }) => {

  const [isEdittingWeight, setIsEdittingWeight] = useState(false)

  return (
    <div className='weightListItem'>
      <div className="weightListText">
        <h3 className="weightListItemPrimary">{new Date(date).toLocaleString()}</h3>
        <h4 className="weightListItemSecondary">{weight.toFixed(1) + ' ' + weightUnit}</h4>
      </div>
      <BsTrash className="weightListIcon weightListDelete" style={{marginLeft: 5}} onClick={() => onDelete(date)}/>
      <BsPencilSquare className="weightListIcon" onClick={() => setIsEdittingWeight(true)}/>
      {isEdittingWeight && <Modal setIsUsingModal={setIsEdittingWeight} weightUnit={weightUnit} onSubmitAction={onEditWeight} title="Edit Weight" weightData={{'date':date,'weight':weight}}/>}
      <hr style={{margin: 0}}/>
    </div>
  )
}

export default WeightListItem